window.assetsFolder = "/assets/VelirSite-build";
